export default Object.freeze({
  EntityField: 1,
  FormField: 2,
  Action: 3,
  ListField: 4,
  Process: 5,
});
